// src/components/RPA/buttons/UploadARConfirmationButton.js
// ✅ FIXED - AR Confirmation Upload (Step 11) - Correct API Route
import React, { useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API || 'http://localhost:8000';

const UploadARConfirmationButton = ({ docId, disabledHint, onDone }) => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const downloadTemplate = () => {
    const csv = `Customer Name,Account Number,Balance Per Books,Balance Per Customer,Confirmation Date,Response Date,Status,Notes,Confirmation Method
Acme Corporation,AR-001,150000,150000,12/31/2024,01/10/2025,matched,Confirmed via email,positive
TechStart Inc,AR-002,75000,72000,12/31/2024,01/12/2025,exception,Customer disputes $3000 invoice,positive
Global Industries,AR-003,250000,250000,12/31/2024,01/15/2025,matched,Confirmed via letter,positive`;
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'AR_Confirmation_Template.csv';
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleUpload = async () => {
    if (!file) {
      setError('Please select a file');
      return;
    }

    if (!docId) {
      setError('No document ID provided');
      return;
    }

    setUploading(true);
    setError(null);

    const formData = new FormData();
    formData.append('arConfirmation', file);

    try {
      // ✅ FIXED: Use correct route pattern /admin/rpa/docs/${docId}/ar-confirmations/upload
      const res = await axios.post(
        `${API_URL}/admin/rpa/docs/${docId}/ar-confirmations/upload`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          withCredentials: true
        }
      );
      console.log('[AR_CONF] Success:', res.data);
      setResult(res.data);
      if (onDone) setTimeout(onDone, 2000);
    } catch (err) {
      console.error('[AR_CONF] Error:', err);
      setError(err.response?.data?.message || 'Upload failed');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{ padding: '20px', background: '#f8f9fa', borderRadius: '8px' }}>
      <h4 style={{ marginTop: 0, color: '#2c3e50' }}>📋 AR Confirmations (Step 11)</h4>
      <p style={{ fontSize: '14px', color: '#6c757d' }}>
        Upload accounts receivable confirmation responses. Verifies customer balances independently.
      </p>

      {disabledHint && (
        <div style={{ padding: '10px', background: '#fff3cd', borderRadius: '6px', marginBottom: '12px', fontSize: '14px' }}>
          ⚠️ {disabledHint}
        </div>
      )}

      <button 
        onClick={downloadTemplate} 
        style={{ 
          padding: '8px 16px', 
          background: '#6c757d', 
          color: 'white', 
          border: 'none', 
          borderRadius: '6px', 
          marginBottom: '12px', 
          cursor: 'pointer',
          fontSize: '14px'
        }}
      >
        📄 Download Template
      </button>

      <input 
        type="file" 
        accept=".csv,.txt" 
        onChange={(e) => { setFile(e.target.files[0]); setError(null); setResult(null); }} 
        disabled={!!disabledHint || uploading} 
        style={{ display: 'block', marginBottom: '12px' }} 
      />

      {file && (
        <div style={{ padding: '8px', background: '#e7f3ff', borderRadius: '4px', marginBottom: '12px', fontSize: '13px' }}>
          📎 {file.name}
        </div>
      )}

      <button 
        onClick={handleUpload} 
        disabled={!file || uploading || !!disabledHint} 
        style={{ 
          padding: '12px 24px', 
          background: !file || uploading || disabledHint ? '#ccc' : '#007bff', 
          color: 'white', 
          border: 'none', 
          borderRadius: '6px', 
          cursor: !file || uploading || disabledHint ? 'not-allowed' : 'pointer', 
          fontWeight: '600',
          fontSize: '15px',
          width: '100%'
        }}
      >
        {uploading ? '⏳ Uploading AR Confirmations...' : '✅ Upload AR Confirmations'}
      </button>

      {error && (
        <div style={{ marginTop: '12px', padding: '12px', background: '#f8d7da', color: '#721c24', borderRadius: '6px', fontSize: '14px' }}>
          ❌ {error}
        </div>
      )}
      
      {result && (
        <div style={{ marginTop: '12px', padding: '12px', background: '#d4edda', color: '#155724', borderRadius: '6px' }}>
          <strong>✅ AR Confirmations Uploaded Successfully!</strong>
          <div style={{ marginTop: '8px', fontSize: '13px' }}>
            • Total Confirmations: {result.summary?.totalConfirmations || 0}<br/>
            • Matched: {result.summary?.matchedCount || 0}<br/>
            • Exceptions: {result.summary?.exceptionCount || 0}<br/>
            • Response Rate: {result.summary?.responseRate || 0}%
          </div>
        </div>
      )}
    </div>
  );
};

export default UploadARConfirmationButton;